import { lazy } from '../../../shared/deployment';

export const MeetingUpdate = lazy(() => import('./MeetingUpdate'));
export const MeetingRead = lazy(() => import('./MeetingRead'));
export const MeetingCreate = lazy(() => import('./MeetingCreate'));
